import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const DownloadIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>(({ tooltipTitle, ...props }, ref) => {
  const { t } = useTranslation();
  const resolvedTooltipTitle = tooltipTitle ?? t('common.download', 'Download');

  return (
    <IconButton ref={ref} {...props} tooltipTitle={resolvedTooltipTitle}>
      <DownloadIcon color="inherit" />
    </IconButton>
  );
});

DownloadIconButton.displayName = 'DownloadIconButton';
export default DownloadIconButton;
